export default "__VITE_ASSET__7b45cf62__"